import { GWidget } from "./GWidget";
import { Text } from "../display/Text";
import { HideFlags, NodeFlags } from "../Const";
import { TextFitContent } from "./Const";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { TransformKind } from "../display/SpriteConst";
import { Translations } from "./Translations";
import { Event } from "../events/Event";
export class GTextField extends GWidget {
    constructor() {
        super();
        this._fitContent = 0;
        this.textIns = new Text();
        this.textIns.hideFlags |= HideFlags.HideAndDontSave;
        this.textIns.padding.fill(2);
        this.textIns._onPostLayout = () => this._onPostLayout();
        this.textIns._onTranslate = Translations.translate;
        this.textIns.on(Event.LINK, (href) => this.event(Event.LINK, href));
        this.addChild(this.textIns);
    }
    get textWidth() {
        return this.textIns.textWidth;
    }
    get textHeight() {
        return this.textIns.textHeight;
    }
    get text() {
        return this.textIns.text;
    }
    set text(value) {
        this.textIns.text = value;
    }
    get font() {
        return this.textIns.font;
    }
    set font(value) {
        this.textIns.font = value;
    }
    get fontSize() {
        return this.textIns.fontSize;
    }
    set fontSize(value) {
        this.textIns.fontSize = value;
    }
    get color() {
        return this.textIns.color;
    }
    set color(value) {
        this.textIns.color = value;
    }
    get bold() {
        return this.textIns.bold;
    }
    set bold(value) {
        this.textIns.bold = value;
    }
    get italic() {
        return this.textIns.italic;
    }
    set italic(value) {
        this.textIns.italic = value;
    }
    get align() {
        return this.textIns.align;
    }
    set align(value) {
        this.textIns.align = value;
    }
    get valign() {
        return this.textIns.valign;
    }
    set valign(value) {
        this.textIns.valign = value;
    }
    get alignItems() {
        return this.textIns.alignItems;
    }
    set alignItems(value) {
        this.textIns.alignItems = value;
    }
    get wordWrap() {
        return this.textIns.wordWrap;
    }
    set wordWrap(value) {
        this.textIns.wordWrap = value;
    }
    get fitContent() {
        return this._fitContent;
    }
    set fitContent(value) {
        if (this._fitContent != value) {
            if ((value == TextFitContent.Both || value == TextFitContent.Height)
                && !SerializeUtil.isDeserializing
                && (!this._getBit(NodeFlags.EDITING_NODE) || this.textIns.textWidth > 0 && this.textIns.textHeight > 0)) {
                if (value == TextFitContent.Height)
                    this.height = this.textIns.textHeight;
                else
                    this.size(this.textIns.textWidth, this.textIns.textHeight);
            }
            this._fitContent = value;
        }
    }
    get leading() {
        return this.textIns.leading;
    }
    set leading(value) {
        this.textIns.leading = value;
    }
    get padding() {
        return this.textIns.padding;
    }
    set padding(value) {
        this.textIns.padding = value;
    }
    get stroke() {
        return this.textIns.stroke;
    }
    set stroke(value) {
        this.textIns.stroke = value;
    }
    get strokeColor() {
        return this.textIns.strokeColor;
    }
    set strokeColor(value) {
        this.textIns.strokeColor = value;
    }
    get overflow() {
        return this.textIns.overflow;
    }
    set overflow(value) {
        this.textIns.overflow = value;
    }
    get underline() {
        return this.textIns.underline;
    }
    set underline(value) {
        this.textIns.underline = value;
    }
    get underlineColor() {
        return this.textIns.underlineColor;
    }
    set underlineColor(value) {
        this.textIns.underlineColor = value;
    }
    get strikethrough() {
        return this.textIns.strikethrough;
    }
    set strikethrough(value) {
        this.textIns.strikethrough = value;
    }
    get strikethroughColor() {
        return this.textIns.strikethroughColor;
    }
    set strikethroughColor(value) {
        this.textIns.strikethroughColor = value;
    }
    get html() {
        return this.textIns.html;
    }
    set html(value) {
        this.textIns.html = value;
    }
    get ubb() {
        return this.textIns.ubb;
    }
    set ubb(value) {
        this.textIns.ubb = value;
    }
    get maxWidth() {
        return this.textIns.maxWidth;
    }
    set maxWidth(value) {
        this.textIns.maxWidth = value;
    }
    get singleCharRender() {
        return this.textIns.singleCharRender;
    }
    set singleCharRender(value) {
        this.textIns.singleCharRender = value;
    }
    get templateVars() {
        return this.textIns.templateVars;
    }
    set templateVars(value) {
        this.textIns.templateVars = value;
    }
    setVar(name, value) {
        this.textIns.setVar(name, value);
        return this;
    }
    size(width, height) {
        if (this._fitContent == TextFitContent.Both && !this._fitFlag
            && (!this._getBit(NodeFlags.EDITING_NODE) || this.textIns.textWidth > 0))
            width = this._width;
        if ((this._fitContent == TextFitContent.Both || this._fitContent == TextFitContent.Height) && !this._fitFlag
            && (!this._getBit(NodeFlags.EDITING_NODE) || this.textIns.textHeight > 0))
            height = this._height;
        return super.size(width, height);
    }
    typeset(force) {
        this.textIns.typeset(force);
        return this;
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Width) != 0)
            this.textIns.width = this._width;
        if ((kind & TransformKind.Height) != 0)
            this.textIns.height = this._height;
    }
    _onPostLayout() {
        if ((this._fitContent == TextFitContent.Both || this._fitContent == TextFitContent.Height)
            && (!this._getBit(NodeFlags.EDITING_NODE) || this.textIns.textWidth > 0 && this.textIns.textHeight > 0)) {
            this._fitFlag = true;
            if (this._fitContent == TextFitContent.Height)
                this.height = this.textIns.textHeight;
            else
                this.size(this.textIns.textWidth, this.textIns.textHeight);
            this._fitFlag = false;
        }
    }
}
